import { useWorkspaceContext } from "@state/workspaceContext";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function useSwitchToPersonalView() {
    const { changeActiveWorkspace } = useWorkspaceContext();

    const navigate = useNavigate();

    return useCallback(() => {
        changeActiveWorkspace(null);
        navigate("/");
    }, [changeActiveWorkspace, navigate]);
}
